module.exports = __webpack_public_path__ + "img/loading.e7d2c7cc.png";